export default "__VITE_ASSET__ByZIz8cU__"